import { render, staticRenderFns } from "./DsbOrderShipments.vue?vue&type=template&id=2dd056f1&scoped=true"
import script from "./DsbOrderShipments.vue?vue&type=script&lang=ts"
export * from "./DsbOrderShipments.vue?vue&type=script&lang=ts"
import style0 from "./DsbOrderShipments.vue?vue&type=style&index=0&id=2dd056f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd056f1",
  null
  
)

export default component.exports